<div class="container">
  <pagination-controls
    class="app-pagination"
    (pageChange)="pageChange.emit($event)"
    [previousLabel]="'SHARED.PAGING.PREVIOUS' | translate"
    [nextLabel]="'SHARED.PAGING.NEXT' | translate"
  ></pagination-controls>
  <form [formGroup]="form">
    <eps-select
      [options]="itemsPerPageOptions"
      formControlName="itemsPerPage"
      labelPosition="none"
      (ngModelChange)="itemsPerPageChange.emit(+form.value.itemsPerPage)"
      [clearable]="false"
      ></eps-select>
  </form>
</div>
